import React from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncWarehouseSelect } from '../../Shared/AsyncWarehouseSelect'
import AsyncClientSelect from '../../Shared/AsyncClientSelect'
import AsyncCargoSelect from '../../Shared/AsyncCargoSelect'
import AsyncDriverSelect from '../../Shared/AsyncDriverSelect'
import PriceInput from '../../Shared/PriceInput'
import WarehouseReceiptProductOperationsTable from '../../Shared/WarehouseReceiptProductOperationsTable'
import unitTypes from '../../../_constants/unitTypes'


export default ({ touched, errors, setFieldValue, values, handleBlur, categoryType, unitProductOperationType }) => (
  <div className="row">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <div className="row">
        <div className="form-inline">

          <div className="col-md-4">
            <label>نام انبار</label>
            <AsyncWarehouseSelect
              // categoryType={categoryType}
              defaultValue={values.unitId}
              onChange={(val, unitType_) => {

                if (unitType_ !== undefined) {

                  var unitType = (unitTypes.filter(el => el.value === unitType_)[0]);

                  if (unitType !== undefined) {

                    categoryType = unitType.categoryType;

                    setFieldValue('categoryType', categoryType)

                  }

                }
                setFieldValue('items', [])
                setFieldValue('dto', undefined)
                setFieldValue('unitId', val)
              }}

              className={getIn(touched, "unitId") ? getIn(errors, "unitId") ? "semantic-select-box" : "semantic-select-box" : "semantic-select-box"}
            />
            <ErrorMessage component={ErrorPopUp} name="unitId" />
          </div>

          <div className="col-md-4">
            <label>طرف حساب</label>
            <AsyncClientSelect
              defaultValue={values.clientId}
              onChange={(val) => {
                console.log(val);
                // setFieldValue('dto', undefined)
                setFieldValue('clientId', val.value)
              }}

              className={getIn(touched, "clientId") ? getIn(errors, "clientId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="clientId" />
          </div>

          <div className="col-md-4">
            <label>باربری</label>
            <AsyncCargoSelect
              defaultValue={values.cargoId}
              onChange={(val) => {
                console.log(val);
                // setFieldValue('dto', undefined)
                setFieldValue('cargoId', val.value)
              }}

              className={getIn(touched, "cargoId") ? getIn(errors, "cargoId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="cargoId" />
          </div>

          <div className="clearfix"></div>

          <div className="col-md-4">
            <label>راننده</label>
            <AsyncDriverSelect
              defaultValue={values.driverId}
              onChange={(val) => {
                console.log(val);
                // setFieldValue('dto', undefined)
                setFieldValue('driverId', val.value)
              }}

              className={getIn(touched, "driverId") ? getIn(errors, "driverId") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="driverId" />
          </div>

          <div className="col-md-4 col-sm-12">
            <label>شماره بارنامه</label>
            <Field type="text"

              name="waybillNumber"
              className={
                getIn(errors, "waybillNumber") &&
                  getIn(touched, "waybillNumber")
                  ? "text-input has-error "
                  : "text-input required "
              }
            />
            <ErrorMessage component={ErrorPopUp} name="waybillNumber" />
          </div>

          <div className="col-md-4">
            <label>مبلغ کرایه</label>
            <PriceInput
              value={values.amount}
              onChange={(val) => {
                console.log(val);

                setFieldValue('amount', val)
              }}
              className={
                getIn(errors, "amount") &&
                  getIn(touched, "amount")
                  ? "text-input has-error "
                  : "text-input required "
              }
            />
            <ErrorMessage component={ErrorPopUp} name="amount" />
          </div>

          <div className="clearfix"></div>

          <div className="col-md-12 col-sm-12">
            <label>توضیحات</label>
            <Field name="description" rows="1"
              render={({ field }) =>
                <textarea {...field}
                  value={values.description || ''}
                  className="textarea short rtl"
                />}
            />
          </div>




          {/* <div className="col-md-12 col-sm-12">
            <hr />
            <fieldset className="fieldset">
              <WarehouseReceiptProductOperationsTable
                unitId={values.unitId}
                dto={values.dto}
                // brandId={values.brandId}
                // clientId={values.clientId}
                // unitId={values.unitId}
                unitProductOperationType={unitProductOperationType}
                // defaultValue={values.productId}
                onChange={(e) => {
                  // setFieldValue('list', e)
                  console.log(e);
                  
                }}

                className={getIn(touched, "list") ? getIn(errors, "list") ? "semantic-select-box has-error" : "semantic-select-box" : "semantic-select-box has-error"}
              />
            </fieldset>
            <ErrorMessage component={ErrorPopUp} name="list" />
          </div> */}


        </div>
      </div>

    </div>

  </div>
);